import React from "react"
import PropTypes from "prop-types"
import ItemNameCountShape from "../../state/shapes/ItemNameCountShape"
import Widget from "../layout/widget/Widget"
import PieChart from "../charts/generic/PieChart"

function ChallengesFaced({ exportEndpoint, appliedFilters, data, subtitleKey, sampleSize }) {
  const titleKey = "Widgets.ChallengesFaced.Title"
  return (
    <Widget
      columns={1}
      titleKey={titleKey}
      helpKey="Widgets.ChallengesFaced.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      subtitleKey={subtitleKey}
      sampleSize={sampleSize}
    >
      <PieChart data={data} singularTooltipDescriptorKey="Common.Person" pluralTooltipDescriptorKey="Common.People" titleKey={titleKey} subtitleKey={subtitleKey}/>
    </Widget>
  )
}

ChallengesFaced.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(ItemNameCountShape)).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string,
  sampleSize: PropTypes.object
}

export default ChallengesFaced



// WEBPACK FOOTER //
// ./src/components/widgets/ChallengesFaced.jsx